import ReactGA from 'react-ga';

let oldLocation = false;

export default (history) => {
  ReactGA.initialize('UA-167127429-1');
  ReactGA.pageview(window.location.pathname + window.location.search);
  history.listen((location) => {
    const newLocation = location.pathname + location.search;
    if (newLocation !== oldLocation) {
      oldLocation = newLocation;
      window.ga('set', 'page', );
      window.ga('send', 'pageview');
    }
  });
}